import { collection, getDocs, query, where } from 'firebase/firestore';
import { db } from '../config';
import { CHUNK_CONCURRENCY, chunkIds, forEachLimited } from './batchedIn';
import type { CountRow, MembershipRow } from '@/lib/groups/listMembership';

// Reads behind the groups list (lib/groups/listMembership): the user's own
// rows once, and the listed groups' member rows 30 groups per query.

/** The user's groupMembers rows (which groups, and the role in each). */
export async function getUserGroupMemberRows(userId: string): Promise<MembershipRow[]> {
  const snap = await getDocs(query(collection(db, 'groupMembers'), where('userId', '==', userId)));
  return snap.docs.map((d) => ({ groupId: d.data().groupId, role: d.data().role }));
}

/** Organizations the user has any organizationMembers row in. */
export async function getUserOrganizationIds(userId: string): Promise<string[]> {
  const snap = await getDocs(query(collection(db, 'organizationMembers'), where('userId', '==', userId)));
  return snap.docs.map((d) => d.data().organizationId).filter((id): id is string => typeof id === 'string');
}

/** groupMembers rows (group + user only) of the given groups. */
export async function getMemberRowsOfGroups(groupIds: string[]): Promise<CountRow[]> {
  const rows: CountRow[] = [];
  await forEachLimited(chunkIds(groupIds), CHUNK_CONCURRENCY, async (part) => {
    const snap = await getDocs(query(collection(db, 'groupMembers'), where('groupId', 'in', part)));
    snap.docs.forEach((d) => rows.push({ groupId: d.data().groupId, userId: d.data().userId }));
  });
  return rows;
}
